import store from '@/store';
import { EventBus } from '@/event-bus';

export default class VoiceOnHoldEvent {
  constructor(body) {
    window.console.log('[VoiceOnHoldEvent]', JSON.parse(JSON.stringify(body)));

    EventBus.$emit('new-voice-hold');

    store.dispatch('channel/setVoiceOnHold', body.voicesOnHold);
  }
}
